<template>
  <div id="app">
    <navbar/>
    <div class="container" id="main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/layout/navbar'

export default {
  name: 'app',
  components: { Navbar }
}
</script>

<style lang="scss">
  @import 'assets/styles/bootstrap';

  #main {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// app.vue?3b36e83d